import React from 'react';
import { getConfig } from '@chegg-web-tools/config-plugin';
import styled from 'styled-components';
import { socialMediaLinks } from '@chegg-me-components/footer-props';
import { breakpoints } from '@chegg-ui/theme';
import { SignedOutFooter } from '@chegg-me-components/signed-out-footer';

const FooterEl = styled.footer`
  width: 100%;
  background-color: white;
  position: relative;
  bottom: 0;
  z-index: 1;
  padding: 0;

  @media only screen and (max-width: ${breakpoints.md.max}) {
    position: static;
  }
  > footer {
    margin: 0 auto;
    background: white;
    padding-top: 0;
    div[data-test='page-grid'] {
      background: white;
      margin-top: 0;
    }
    > div:first-child {
      display: none;
    }
  }
`;

interface FooterProps {
  baseCheggUrl: string;
  locale: string | undefined;
}

export function Footer({ baseCheggUrl, locale }: FooterProps) {
  return (
    <FooterEl>
      <SignedOutFooter locale={locale} socialMediaLinks={socialMediaLinks} envUrl={baseCheggUrl} />
    </FooterEl>
  );
}
